import { render, staticRenderFns } from "./deleteMerchant.vue?vue&type=template&id=0d7c948a"
import script from "./deleteMerchant.vue?vue&type=script&lang=js"
export * from "./deleteMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports